var React = require('react');

function CombinedPurchase (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.2","d":"M9.909 13.546H1V10.8c0-.772.461-1.468 1.175-1.764.722-.299 1.797-.582 3.28-.582 1.482 0 2.557.283 3.28.583.713.295 1.174.991 1.174 1.763v2.745zM9.91 13.546H15v-2.059c0-.579-.33-1.1-.839-1.322-.516-.225-1.284-.437-2.343-.437-.63 0-1.476.273-1.909.381M5.455 6.546C6.86 6.546 8 5.406 8 4c0-1.406-1.14-2.546-2.545-2.546-1.406 0-2.546 1.14-2.546 2.546 0 1.405 1.14 2.545 2.546 2.545zM11.818 7.818c1.055 0 1.91-.855 1.91-1.909S12.872 4 11.817 4c-1.054 0-1.909.855-1.909 1.91 0 1.053.855 1.908 1.91 1.908z"}));
}

CombinedPurchase.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = CombinedPurchase;

CombinedPurchase.default = CombinedPurchase;
